module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nome",
      "required": "",
      "label": "Nome"
    },
    model: {
      value: (_vm.medico.nome),
      callback: function($$v) {
        _vm.$set(_vm.medico, "nome", $$v)
      },
      expression: "medico.nome"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "cpf",
      "type": "number",
      "required": "",
      "label": "CPF"
    },
    model: {
      value: (_vm.medico.cpf),
      callback: function($$v) {
        _vm.$set(_vm.medico, "cpf", $$v)
      },
      expression: "medico.cpf"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crm",
      "required": "",
      "label": "CRM"
    },
    model: {
      value: (_vm.medico.crm),
      callback: function($$v) {
        _vm.$set(_vm.medico, "crm", $$v)
      },
      expression: "medico.crm"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "crmUf",
      "required": "",
      "label": "CRM UF (sigla)"
    },
    model: {
      value: (_vm.medico.crmUf),
      callback: function($$v) {
        _vm.$set(_vm.medico, "crmUf", $$v)
      },
      expression: "medico.crmUf"
    }
  })], 1)], 1), _vm._v(" "), (_vm.medico.id) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    ref: "fileTextField",
    attrs: {
      "prepend-icon": "attach_file",
      "single-line": "",
      "label": "certificado"
    },
    nativeOn: {
      "click": function($event) {
        _vm.onFocus($event)
      }
    },
    model: {
      value: (_vm.medico.certificado),
      callback: function($$v) {
        _vm.$set(_vm.medico, "certificado", $$v)
      },
      expression: "medico.certificado"
    }
  }), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "accept": "*",
      "multiple": false
    },
    on: {
      "change": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "senhaCertificado",
      "label": "Senha Certificado",
      "append-icon": _vm.mostrarSenha ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.mostrarSenha = !_vm.mostrarSenha); },
      "type": _vm.mostrarSenha ? 'password' : 'text'
    },
    model: {
      value: (_vm.medico.senhaCertificado),
      callback: function($$v) {
        _vm.$set(_vm.medico, "senhaCertificado", $$v)
      },
      expression: "medico.senhaCertificado"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Vencimento Certificado",
      "prepend-icon": "event",
      "readonly": ""
    },
    model: {
      value: (_vm.dataVencimentoCertificado),
      callback: function($$v) {
        _vm.dataVencimentoCertificado = $$v
      },
      expression: "dataVencimentoCertificado"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Ativo",
      "color": "primary"
    },
    model: {
      value: (_vm.medico.ativo),
      callback: function($$v) {
        _vm.$set(_vm.medico, "ativo", $$v)
      },
      expression: "medico.ativo"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35d053fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MedicoForm.vue
// module id = 367
// module chunks = 1